import { render, staticRenderFns } from "./muticheck.vue?vue&type=template&id=57783838&scoped=true"
import script from "./muticheck.vue?vue&type=script&lang=js"
export * from "./muticheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57783838",
  null
  
)

export default component.exports